
import io from 'socket.io-client';


export const Socket = io(process.env.REACT_APP_SOCKET,{
    transports: ['websocket'],
    reconnect: true
 });

Socket.on('connect', async function (data) {
    
    const trackerId = localStorage.getItem("trackerId")
    console.log("Socket connected",Socket.id)
    Socket.emit('clickid', { clickid:trackerId, softwareVersion: localStorage.getItem("softwareVersion") })
});



Socket.on("connect_error", (error) => {
    if (Socket.active) {
        console.log("temp",error)
      // temporary failure, the socket will automatically try to reconnect
    } else {
      // the connection was denied by the server
      // in that case, `socket.connect()` must be manually called in order to reconnect
      console.log("tot",error.message);
    }
  });



/*
Socket.on('disconnect', async function (data) {
  setTimeout(()=>{
    Socket.emit('removeOldSocketId', { OldSocketId:localStorage.getItem("socketId"),socketId:Socket.id })
    console.log("DISCONNESSO",Socket.id)
  },5000)
  
  
});*/
